import { FormattedMessage as FM } from "react-intl";

import { Bars3Icon } from "components/Icons";
import { getContrastText } from "../helpers/colors";
import { hideImage } from "../helpers/images";

function PreviewHeader({ logo, title, colors }) {
  const primary = colors.primary_color;
  return (
    <div
      className="flex h-11 items-center justify-between gap-2 px-3"
      style={{ backgroundColor: primary, color: getContrastText(primary) }}
    >
      {logo ? (
        <img
          src={logo}
          alt=""
          onError={hideImage}
          className="h-6 max-w-[60%] object-contain"
        />
      ) : (
        <span className="truncate text-xs font-semibold uppercase tracking-wide">
          {title || <FM id="melhous.dash.preview.hotel_name" />}
        </span>
      )}
      <Bars3Icon width={18} className="shrink-0 fill-current" />
    </div>
  );
}

export default PreviewHeader;
